export default __webpack_public_path__ + "static/media/editorial.b9f283f2.png";